import { useCancellationPolicy } from "@/hooks/useCancellationPolicy";

interface CancellationPolicyBlockProps {
  eventStartTime: string;
}

export default function CancellationPolicyBlock({ eventStartTime }: CancellationPolicyBlockProps) {
  const policy = useCancellationPolicy(eventStartTime);
  if (policy.isLoading) return null;

  return (
    <section className="mt-6 bg-white rounded-lg p-4 shadow-md mb-4">
      <h3 className="text-base font-semibold text-foreground mb-2">
        Cancellation &amp; refund policy
      </h3>
      <p className="text-sm text-muted-foreground leading-relaxed">
        {policy.displayText}
      </p>
      <p className="text-sm text-muted-foreground leading-relaxed mt-2">
        Refunds are issued as Nimi credits, added to your account instantly and can be used towards any future bookings.
      </p>
    </section>
  );
}
